module.exports = __webpack_public_path__ + "static/img/u99.9704edd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/clay/u99.png
// module id = EAzJ
// module chunks = 0